import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import * as S from './styles';

type Tab = {
  active: boolean;
  id: string;
  image?: React.ReactElement;
  title: React.ReactNode;
  to: string;
  scrollToTop?: boolean;
};

type TabProps = Tab & {
  onClick?: (tab: string) => void;
};

type OwnProps = {
  className?: string;
  onClick?: (tab: string) => void;
  tabs: Tab[];
  background?: boolean;
  isSticky?: boolean;
};

const TabItem = ({
  active,
  id,
  image,
  onClick,
  title,
  to,
  scrollToTop,
}: TabProps) => {
  const history = useHistory();
  const handleOnClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (scrollToTop) {
        e.preventDefault();
        e.stopPropagation();
        history.push(history.location.pathname + history.location.search);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      if (!onClick) return null;
      return onClick(id);
    },
    [id, onClick, scrollToTop, history]
  );

  return (
    <S.TabLink active={active} onClick={handleOnClick} to={to}>
      {image && <S.Image>{image}</S.Image>}
      {title}
    </S.TabLink>
  );
};

const Tabs = React.forwardRef<HTMLElement, OwnProps>(
  ({ className, onClick, tabs, background, isSticky }, ref) => (
    <S.Tabs className={className} ref={ref}>
      <S.TabsBackground background={background} isSticky={isSticky}>
        <S.Wrapper>
          {tabs.map(tab => (
            <TabItem {...tab} key={tab.id} onClick={onClick} />
          ))}
        </S.Wrapper>
      </S.TabsBackground>
    </S.Tabs>
  )
);

export default Tabs;
